import willImg from "@/assets/logo.png";

// Hold a strong reference so the browser keeps Will's image
// decoded in memory — loading screens render instantly.
const img = new Image();
img.src = willImg;
img.decoding = "async";
// @ts-ignore - fetchPriority is supported in modern browsers
img.fetchPriority = "high";
if (img.decode) {
  img.decode().catch(() => {});
}

// Pin to window so it never gets GC'd
(window as any).__willImg = img;

export const willSrc = willImg;
export const willImage = img;
